export default __webpack_public_path__ + "ruby@2x.d5512597.jpg";